import AriaDialog from '@zoom/zoom-ui/src/utils/aria-dialog';

/**
 * Usage: Assign the dom of dialog body to $ref.mx_ariaBody, 
 *        and use mx_ariaDialogOpened to control the open/close state
 */
export default {
  data() {
    return {
      mx_ariaDialog: null,
      mx_ariaDialogOpened: false
    }
  },
  watch: {
    mx_ariaDialogOpened(val) {
      if (val) {
        this.mx_onAriaDialogOpen()
      } else {
        this.mx_onAriaDialogClose()
      }
    }
  },
  methods: {
    mx_onAriaDialogOpen() {
      const focusAfterClosed = document.activeElement
      this.$nextTick(() => {
        this.mx_ariaDialog = new AriaDialog(this.$refs.mx_ariaBody, focusAfterClosed, true)
      })
    },
    mx_onAriaDialogClose() {
      this.mx_destroyAriaDialog()
    },
    mx_destroyAriaDialog() {
      this.mx_ariaDialog && this.mx_ariaDialog.closeDialog()
      this.mx_ariaDialog = null
    }
  },
  beforeDestroy() {
    this.mx_destroyAriaDialog()
  }
}